import cookie from 'js-cookie';

import config from 'config';

type NeptuneTrackEventProperties = Record<string, string | number>;

function trackError(eventName: string, properties?: NeptuneTrackEventProperties): void {
  void eventName;
  void properties;
  // do not track in Intercom
}

function track(eventName: string, properties?: NeptuneTrackEventProperties) {
  try {
    if (typeof window.Intercom === 'function') {
      window.Intercom('trackEvent', eventName, properties);
    }
  } catch {
    /* ignore exceptions */
  }
}

function setProperty(key: string, value: string | number) {
  setProperties({ [key]: value });
}

function setProperties(properties: NeptuneTrackEventProperties) {
  try {
    if (typeof window.Intercom === 'function') {
      window.Intercom('update', properties);
    }
  } catch {
    /* ignore exceptions */
  }
}

function logout(): void {
  try {
    if (typeof window.Intercom === 'function') {
      const options = {
        domain: config.neptuneCookieDomain,
        path: '/',
      };
      window.Intercom('hide');
      window.Intercom('shutdown');
      cookie.remove('neptune-uid', options);
      delete window.intercomSettings;
    }
  } catch {
    /* ignore exceptions */
  }
}

function startProductTour(tourId: number) {
  try {
    window.Intercom('startTour', tourId);
  } catch {
    /* ignore exceptions */
  }

  if (config.appEnv !== 'dist') {
    // eslint-disable-next-line no-console
    console.warn(`Intercom tour ${tourId} should have started right now`);
  }
}

export const neptune = {
  logout,
  trackError,
  track,
  setProperty,
  setProperties,
  startProductTour,
};
